import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule} from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-dialog-title',
  imports: [MatDialogModule, MatIconModule, MatButtonModule],
  templateUrl: './dialog-title.component.html',
  styleUrl: './dialog-title.component.scss',
  standalone: true,
})
export class DialogTitleComponent {

}
